
      var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPauseCarousel = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#pauseCarousel_66427947345c5834__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 17,
  r: 14.75,
  stroke: "#E1E1E1",
  strokeWidth: 2.5
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#pauseCarousel_66427947345c5834__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 21.5v-10",
  stroke: "#E1E1E1",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#pauseCarousel_66427947345c5834__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 21.5v-10",
  stroke: "#E1E1E1",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "pauseCarousel_66427947345c5834__a",
  x: 0,
  y: 0,
  width: 36,
  height: 36,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_21569_11664"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_21569_11664",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "pauseCarousel_66427947345c5834__b",
  x: 11.75,
  y: 9.25,
  width: 6.5,
  height: 16.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_21569_11664"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_21569_11664",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "pauseCarousel_66427947345c5834__c",
  x: 17.75,
  y: 9.25,
  width: 6.5,
  height: 16.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_21569_11664"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_21569_11664",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"36\" height=\"36\" viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g filter=\"url(#filter0_d_21569_11664)\">\r\n<circle cx=\"18\" cy=\"17\" r=\"14.75\" stroke=\"#E1E1E1\" stroke-width=\"2.5\"/>\r\n</g>\r\n<g filter=\"url(#filter1_d_21569_11664)\">\r\n<path d=\"M15 21.5L15 11.5\" stroke=\"#E1E1E1\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</g>\r\n<g filter=\"url(#filter2_d_21569_11664)\">\r\n<path d=\"M21 21.5V11.5\" stroke=\"#E1E1E1\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</g>\r\n<defs>\r\n<filter id=\"filter0_d_21569_11664\" x=\"0\" y=\"0\" width=\"36\" height=\"36\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"1\"/>\r\n<feGaussianBlur stdDeviation=\"1\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_21569_11664\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_21569_11664\" result=\"shape\"/>\r\n</filter>\r\n<filter id=\"filter1_d_21569_11664\" x=\"11.75\" y=\"9.25\" width=\"6.5\" height=\"16.5\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"1\"/>\r\n<feGaussianBlur stdDeviation=\"1\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_21569_11664\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_21569_11664\" result=\"shape\"/>\r\n</filter>\r\n<filter id=\"filter2_d_21569_11664\" x=\"17.75\" y=\"9.25\" width=\"6.5\" height=\"16.5\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"1\"/>\r\n<feGaussianBlur stdDeviation=\"1\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_21569_11664\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_21569_11664\" result=\"shape\"/>\r\n</filter>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/pauseCarousel.66427947345c5834cf0e95bec837db70.svg"),
        {
          React: SvgPauseCarousel,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      